module.exports = __webpack_public_path__ + "img/sunset.43760b47.svg";